// extracted by mini-css-extract-plugin
export default {"step":"Step_step__zbpbI","stepIcon":"Step_stepIcon__4AU6u","stepContent":"Step_stepContent__8HmqH","stepCounter":"Step_stepCounter__AM7CY","fadeIn":"Step_fadeIn__Sx07B"};